import React from 'react'
import cx from 'classnames'

import Button, { ButtonProps } from 'components/_new/controls/Button/Button'

import s from './SocialButton.scss'
import messages from './messages'


export type SocialButtonProps = Omit<ButtonProps, 'color'> & {
  type: 'facebook' | 'facebookCircle' | 'google' | 'whatsApp' | 'apple'
}

const SocialButton: React.FunctionComponent<SocialButtonProps> = ({ className, type, disabled, ...rest }) => {
  const rootClassName = cx(className, s.root, s[type], {
    [s.disabled]: disabled,
  })

  const title = messages[type]

  return (
    <Button
      className={rootClassName}
      title={title}
      leftIcon={type}
      color={null}
      disabled={disabled}
      {...rest}
    />
  )
}


export default SocialButton
